import React, { useMemo } from 'react';
import { Radio } from 'tea-component';
import useIntls from '@opm/hooks/useIntls';
import type { TXDimension } from './constants';

export interface IXDimensionSegmentProps {
  value: TXDimension;
  canByDate: boolean;
  canByCountry: boolean;
  visible: boolean;
  onChange: (value: TXDimension) => void;
}

export default function XDimensionSegment({
  value,
  canByDate,
  canByCountry,
  visible,
  onChange,
}: IXDimensionSegmentProps) {
  const { intl } = useIntls();

  const options = useMemo(
    () => [
      {
        text: intl('By Country'),
        value: 'country' as TXDimension,
        disabled: !canByCountry,
      },
      {
        text: intl('By Date'),
        value: 'date' as TXDimension,
        disabled: !canByDate,
      },
    ],
    [intl, canByCountry, canByDate],
  );

  if (!visible) {
    return null;
  }

  return (
    <Radio.Group
      className="dbom-x-hashtag-dimension"
      value={value}
      onChange={(v) => onChange(v as TXDimension)}
    >
      {options.map((option) => (
        <Radio
          key={option.value}
          name={option.value}
          disabled={option.disabled}
        >
          {option.text}
        </Radio>
      ))}
    </Radio.Group>
  );
}
